<template>
  <div id="dynamic-text-sidenav">
    <page-editor-alert :text="$t('warning')" variant="warning" />
    <span class="d-block w-100 mt-2">{{ $t('choose_text_slug') }}</span>
    <Dropdown :options="targetOptions" :value="options.fieldName" @change="propChanged('fieldName', $event)" />
  </div>
</template>

<script>
import WidgetSideNavMixin from '@/components/sidenav/landing/panel/widget/Mixin.js'
import PageEditorAlert from '@/components/PageEditorAlert'

export default {
  name: 'DynamicTextSideNav',
  components: {
    PageEditorAlert,
  },
  i18nOptions: { keyPrefix: 'components.sidenav.landing.panel.widget.dynamic-text-side-nav' },
  mixins: [WidgetSideNavMixin],
  computed: {
    targetOptions() {
      return [
        { value: 'product_name', text: this.$t('product_title') },
        { value: 'product_description', text: this.$t('product_description') },
        { value: 'product_price', text: this.$t('product_price') },
        { value: 'product_anchor_price', text: this.$t('product_anchor_price') },
      ]
    },
  },
}
</script>
